export default __webpack_public_path__ + "static/media/ISEO CLASS-9 EXAM PATTERN 2026-27.d6e87e56.pdf";